export default "/images/e6ac8d22c95c6c3a924a89c52ef0fea1.avif";